import { cn } from "@/libraries/cn";

interface FloatingLoaderProps extends React.ComponentProps<"div"> {
	open?: boolean;
}

const FloatingLoader = (props: FloatingLoaderProps) => {
	const { open, className, ...divProps } = props;
	if (!open) return null;
	return (
		<div
			className={cn(
				"absolute z-10 top-0 right-1/2 bg-white rounded-lg p-2 translate-y-3",
				className,
			)}
			{...divProps}
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
				className="animate-spin"
			>
				<title>Loader</title>
				<path stroke="none" d="M0 0h24v24H0z" fill="none" />
				<path d="M12 6l0 -3" />
				<path d="M6 12l-3 0" />
				<path d="M7.75 7.75l-2.15 -2.15" />
			</svg>
		</div>
	);
};

export default FloatingLoader;
